import React from "react";
// routes
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
// components
import {
  ScrollToTop,
  ProgressBarStyle,
  ThemePrimaryColor,
  NotistackProvider,
} from "./components";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";

export default function App() {
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <NotistackProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <GlobalStyles />
            <ProgressBarStyle />
            <ScrollToTop />
            <Router />
          </LocalizationProvider>
        </NotistackProvider>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
